module.exports = __webpack_public_path__ + "static/media/app-error-oh-no.09937c05.png";